
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.207 18.99c.308 0 .547-.103.719-.306.171-.203.257-.473.257-.81v-1.935h.357c.692 0 1.296-.134 1.813-.4.517-.268.92-.656 1.211-1.164.29-.509.436-1.123.436-1.843v-4.95c0-.72-.145-1.338-.436-1.852a2.954 2.954 0 00-1.224-1.185c-.526-.276-1.137-.414-1.835-.414h-1.368v-.567c0-.75-.143-1.39-.431-1.921a2.91 2.91 0 00-1.242-1.22C16.924.14 16.28 0 15.53 0H3.608c-.726 0-1.36.14-1.9.423-.54.281-.96.688-1.26 1.22C.15 2.174 0 2.815 0 3.564v7.652c0 .743.148 1.378.444 1.904.297.526.712.928 1.247 1.207.534.279 1.162.418 1.882.418h1.063v2.17c0 .349.086.62.257.815.172.194.417.292.737.292.22 0 .434-.05.64-.148.206-.1.443-.268.71-.506l2.705-2.413.024.026c.214.223.467.409.757.557.523.267 1.148.401 1.874.401h2.832l2.754 2.362c.261.226.487.398.675.514.19.116.391.174.606.174zM6.004 16.382v-2.326c0-.244-.065-.426-.196-.545a.692.692 0 00-.483-.179H3.747c-.697 0-1.246-.191-1.647-.575-.4-.383-.601-.944-.601-1.682V3.678c0-.738.2-1.3.601-1.687.401-.386.95-.58 1.647-.58h11.634c.71 0 1.262.194 1.66.58.398.387.597.949.597 1.687v.453H12.34c-.726 0-1.35.138-1.874.414A2.825 2.825 0 009.268 5.73c-.276.514-.414 1.131-.414 1.852v4.958c0 .318.027.615.082.892l.042.188-2.974 2.763zm12.82.959L16.2 14.98a1.757 1.757 0 00-.483-.335 1.461 1.461 0 00-.58-.1h-2.666c-.663 0-1.184-.18-1.565-.54-.38-.36-.57-.895-.57-1.604V7.686c0-.703.19-1.237.57-1.603.38-.366.902-.55 1.565-.55h7.904c.668 0 1.19.184 1.568.55.378.366.567.9.567 1.603v4.715c0 .703-.189 1.236-.567 1.599-.377.363-.9.545-1.568.545h-.88a.676.676 0 00-.48.178c-.128.12-.192.298-.192.536v2.083z","fill":"#748190"}})])
          )
        }
      }
    